import type { ClipboardEvent } from "react";

export function handlePlainTextCopy(e: ClipboardEvent<HTMLElement>) {
  const selection = window.getSelection()?.toString() ?? "";
  if (!selection) return;
  e.clipboardData.setData("text/plain", selection);
  e.preventDefault();
}
